// extracted by mini-css-extract-plugin
module.exports = {"MainTitle":"Favourites_MainTitle__32NdO"};